/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */
export { BlobAbortCopyFromURLHeaders, BlobAcquireLeaseHeaders, BlobBreakLeaseHeaders, BlobChangeLeaseHeaders, BlobCopyFromURLHeaders, BlobCreateSnapshotHeaders, BlobDeleteHeaders, BlobDownloadHeaders, BlobGetAccessControlHeaders, BlobGetAccountInfoHeaders, BlobGetPropertiesHeaders, BlobReleaseLeaseHeaders, BlobRenameHeaders, BlobRenewLeaseHeaders, BlobSetAccessControlHeaders, BlobSetHTTPHeadersHeaders, BlobSetMetadataHeaders, BlobSetTierHeaders, BlobStartCopyFromURLHeaders, BlobUndeleteHeaders, DataLakeStorageError, DataLakeStorageErrorError, StorageError } from "../models/mappers";
//# sourceMappingURL=blobMappers.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@azure/storage-blob/dist-esm/src/generated/src/models/blobMappers.js
// module id = 693
// module chunks = 0